module.exports = __webpack_public_path__ + "img/sdk-3-1.9752876.svg";